import type { FC, ReactNode } from 'react'
import type { PricingPlan } from '@/types'

import { Eyebrow } from '@/components/generals/eyebrow'
import { Container } from '@/components/generals/container'
import { RevealText } from '@/components/generals/reveal-text'
import { PricingPlans } from '@/components/sections/pricing-plans'

interface PricingSectionProps {
    plans: Array<PricingPlan>
}

export const PricingSection: FC<PricingSectionProps> = ({ plans }): ReactNode => {
    return (
        <section id='pricing' aria-labelledby='pricing-title' className='bg-cream'>
            <Container className='py-28 md:py-40'>
                <div className='mx-auto max-w-3xl text-center'>
                    <Eyebrow>Pricing</Eyebrow>

                    <RevealText
                        as='h2'
                        id='pricing-title'
                        text='Simple pricing that grows with you.'
                        highlight={['grows with you.']}
                        highlightClassName='text-stone'
                        className='mt-6 font-heading text-display-xl font-medium text-burgundy'
                    />

                    <p data-reveal='' className='mx-auto mt-6 max-w-xl text-lg leading-relaxed text-stone-dark'>
                        Start with a 14-day free trial on Starter or Growth. Upgrade, downgrade or cancel at any time.
                    </p>
                </div>

                <PricingPlans plans={plans} className='mt-14' />
            </Container>
        </section>
    )
}
